import { HugeiconsIcon } from '@hugeicons/react'
import { YoutubeIcon } from '@hugeicons/core-free-icons'
import { useEffect, useState } from 'react'
import Image from './Image'

async function fetchOembed(videoId: string, type: 'video' | 'playlist' = 'video') {
  const url =
    type === 'video'
      ? `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`
      : `https://www.youtube.com/oembed?url=https://youtube.com/playlist?list=${videoId}`
  try {
    const res = await fetch(url)
    return (await res.json()) as {
      author_name?: string
      title?: string
      type?: string
      thumbnail_url?: string
    }
  } catch {
    return {}
  }
}

async function fetchDeArrowTitle(videoId: string): Promise<string | null> {
  try {
    const res = await fetch(`https://sponsor.ajay.app/api/branding?videoID=${videoId}`)
    if (!res.ok) return null
    const data = await res.json()
    return data.titles?.[0]?.title ?? null
  } catch {
    return null
  }
}

export default function YoutubeStaticEmbed({
  id,
  type
}: {
  id: string
  type: 'video' | 'playlist'
}) {
  const [author, setAuthor] = useState<string>('')
  const [title, setTitle] = useState<string>(id)
  const [img, setImage] = useState<null | string>(
    type === 'playlist'
      ? null
      : window.hallway.universe.dearrowYoutube
        ? `https://dearrow-thumb.ajay.app/api/v1/getThumbnail?videoID=${id}`
        : `https://img.youtube.com/vi/${id}/hqdefault.jpg`
  )
  const fallbacks = window.hallway.universe.dearrowYoutube
    ? [`https://img.youtube.com/vi/${id}/hqdefault.jpg`]
    : []

  useEffect(() => {
    if (!id) return

    fetchOembed(id, type).then((data) => {
      if (
        data.type === 'video' /* this will always be 'video' even when we're fetching a playlist */
      ) {
        setTitle((curr) => (curr === id ? data.title || curr : curr))
        setAuthor(data.author_name || '')
        if (data.thumbnail_url && !img) setImage(data.thumbnail_url)
      }
    })

    if (type === 'video' && window.hallway.universe.dearrowYoutube) {
      fetchDeArrowTitle(id).then((title) => {
        if (title) setTitle(title)
      })
    }
  }, [id])

  const href =
    type === 'video'
      ? `https://www.youtube.com/watch?v=${id}`
      : `https://youtube.com/playlist?list=${id}`

  return (
    <div className="mt-2 rounded-lg border overflow-hidden relative">
      <a href={href} target="_blank">
        {img && (
          <Image
            imageUrl={img}
            onFailure={() => {
              const nextFallback = fallbacks.pop()
              if (nextFallback) setImage(nextFallback)
            }}
            alt=""
            className="w-full object-cover aspect-video"
          />
        )}
        <div className="absolute top-0 left-0 right-0 p-3 drop-shadow text-shadow-lg bg-gradient-to-b from-black/70 to-transparent">
          <div className="flex items-center gap-2">
            <HugeiconsIcon icon={YoutubeIcon} size={18} className="shrink-0 text-white" />
            <div className="min-w-0">
              <div className="text-white text-sm font-semibold truncate">{title}</div>
              <div className="text-white/80 text-xs truncate">{author}</div>
            </div>
          </div>
        </div>
      </a>
    </div>
  )
}
